export default __webpack_public_path__ + "static/media/Group 6493@3x.9df3b071.png";